import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/dropdown';

import { Controller } from "stimulus"
import Swal from "sweetalert2";
import EnrollmentService from '../entrypoints/src/admin/services/enrollment-service';

export default class extends Controller {
  // Paint the whole page background warm (#fbfaf8, mockup --bg) so there is no
  // white gap below the content when the viewport is taller than the page.
  // Reverted when navigating away (Turbo tears the controller down).
  connect() {
    this.previousBodyBackground = document.body.style.background;
    document.body.style.background = "#fbfaf8";
  }

  disconnect() {
    document.body.style.background = this.previousBodyBackground || "";
  }

  async applyDiscountPackage(ev) {
    ev.preventDefault();
    let anchor = ev.target;

    if (!this.discount)
      this.discounts = await EnrollmentService.discountPackages(anchor.dataset.enrollmentId);

    if (this.discounts.length == 0)
      return Swal.fire({ icon: 'info', title: 'Escolha um Pacote', text: 'Infelizmente não foi possível encontrar um pacote de desconto que se enquadre nas condições da matrícula!' });

    const { value: formValues } = await Swal.fire({
      title: 'Escolha um Pacote',
      html: `
        <p class="text-left mb-0">Trouxemos para você somente os pacotes de descontos que se enquadraram na matrícula.</p>
        <p class="text-left mt-0">Todos os contratos ativos e mensalidades em abertas serão atualizadas com o desconto selecionado.</p>
        <div class="row mt-3">
          <div class="col-12">
            <div class="form-group text-left">
              <label>Pacote de Desconto</label>
              <select class="form-control" name="package" id="swal-discount-package">
                ${this.discounts.length == 0 ? '<option>Nenhum pacote encontrado</option>' : this.discounts.map((discount) => { return `<option value="${discount.id}">${discount.name}</option>`; })}
              </select>
            </div>
          </div>
        </div>
      `,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      showCloseButton: true,
      showCancelButton: true,
      showConfirmButton: this.discounts.length > 0,
      focusConfirm: true,
      confirmButtonText: 'Aplicar Desconto',
      cancelButtonText: 'Cancelar',
      width: 600,
      preConfirm: () => {
        return {
          discountPackageId: document.getElementById('swal-discount-package').value
        }
      }
    });

    if (!formValues)
      return;

    let htmlForm = `
      <form action="${anchor.dataset.href}" method="post" class="enrollment-apply-discount">
        <input type="hidden" name="discount_package_id" value="${formValues.discountPackageId}" />
        <button class="hidden apply-discount"></button>
      </form>
    `;
    document.querySelector('body').insertAdjacentHTML('afterbegin', htmlForm);
    document.querySelector('form.enrollment-apply-discount button.apply-discount').click();
  }

  removeDiscount(ev) {
    ev.preventDefault();

    Swal.fire({
      title: 'Deseja realmente remover o desconto?',
      icon: 'warning',
      html: 'Todos os contratos ativos e mensalidades abertas, serão atualizadas e perderão o desconto aplicado.',
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      focusConfirm: false,
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sim, quero remover o desconto!',
      cancelButtonText: 'Não, cancelar!',
      width: 600
    }).then((resp) => {
      if (!resp.isConfirmed)
        return;

      let htmlForm = `
        <form action="${ev.target.getAttribute('href')}" method="post" class="enrollment-remove-discount">
          <input type="hidden" name="_method" value="delete" />
          <button class="hidden remove-discount"></button>
        </form>
      `;
      document.querySelector('body').insertAdjacentHTML('afterbegin', htmlForm);
      document.querySelector('form.enrollment-remove-discount button.remove-discount').click();
    });
  }
}